import React, { useEffect, useState } from "react"; 
import Event from "./components/UI/Event";
import hero from "./assets/svg/KALENDAR.webp";
import { Helmet } from 'react-helmet-async';
import Layout from "./Layout";
import axios from "axios";
import { APIURL, STORAGEURL } from "./index";
import Loading from "./components/UI/Loading";
import Lokalita from "./components/UI/Lokalita";

const LokalityPage = () => {
    const [lokalityData, setLokalityData] = useState({}); 
    const [loading, setLoading] = useState(true); 

    const getLokality = async () => {
        await axios
            .post(APIURL + "/collection/items", {
                type: 'tried',
                orderAsc: "ASC", 
                limit: 100, 
                page: 1,
                language: 'cs'
            })
            .then((response) => { 
                setLokalityData(response.data.body);
                setLoading(false);
            });
    };

    useEffect(() => {
        getLokality();
    }, []);
    return (
        <Layout nested={1}>
            <Helmet>
                <title>Navštívili jsme | Nehoda nanečisto</title>
                <meta
                    name="description"
                    content="Navštivte náš stánek na různých akcích po České republice a zažijte dopravní nehodu nanečisto."
                />

                <meta property="og:title" content="Navštívili jsme" />
                <meta
                    property="og:description"
                    content="Navštivte náš stánek na různých akcích po České republice a zažijte dopravní nehodu nanečisto."
                />
                <meta property="og:site_name" content="Nehoda nanečisto" />

                <meta name="twitter:title" content="Navštívili jsme" />
                <meta
                    name="twitter:description"
                    content="Navštivte náš stánek na různých akcích po České republice a zažijte dopravní nehodu nanečisto."
                />
            </Helmet>

            <div className="terminy">
                <div className="terminy__header">
                    <div className="terminy__header__title">
                        <h1>Kde všude jsme byli?</h1>
                        <p> Jako putovní projekt navštěvujeme veřejné i soukromé akce. Pořádáme školení pro firmy, návštěvy v autoškolách a akce pro základní a střední školy. Místa a společnosti, které jsme již navštívili, můžete vidět níže. </p>
                    </div> 
                    <div className="terminy__header__hero">
                       {/** <img src={hero} alt="ilustrace kalendáře" /> */}
                    </div> 
                </div>
                <div className="lokality__box"> 
                    <div className="firmy">  
                        {!loading ? (
                            lokalityData?.items?.map((lokalita, i) => (
                                <Lokalita lokalita={lokalita}/>
                            ))
                        ) : (
                            <Loading />
                        )}
                    </div>  
                </div>
            </div>
        </Layout>
    );
};

export default LokalityPage;
